import { render } from "./ReferralEarnings.vue?vue&type=template&id=1d6ccbfa&scoped=true"
import script from "./ReferralEarnings.vue?vue&type=script&lang=js"
export * from "./ReferralEarnings.vue?vue&type=script&lang=js"

import "./ReferralEarnings.vue?vue&type=style&index=0&id=1d6ccbfa&scoped=true&lang=css"

import exportComponent from "/home/runner/work/admin_6_0/admin_6_0/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1d6ccbfa"]])

export default __exports__